import { useId } from 'react';
import { PrecisionControl } from './PrecisionControl';
import './compact-range.css';

/** A bounded slider and precise typed value always edit the same setting. */
export function CompactRangeControl({ label, detail, inputLabel, sliderLabel, value, min, max, step = 1, unit = '', disabled = false, help, valueText, invalidMessage, onChange, integer = false, externalValue = false }: {
  label: string; value: number; min: number; max: number; step?: number; unit?: string;
  detail?: string; inputLabel?: string; sliderLabel?: string;
  disabled?: boolean; help?: string; valueText?: string; invalidMessage?: string; onChange: (value: number) => void; integer?: boolean; externalValue?: boolean;
}) {
  const id = useId();
  return <div className="compact-range" title={help} data-readout={false}>
    <label htmlFor={id}>{label}{detail && <small>{detail}</small>}</label>
    <input id={id} type="range" aria-label={sliderLabel ?? label} min={min} max={max} step={step} value={value}
      disabled={disabled} aria-valuetext={valueText ?? `${value}${unit}`} onChange={event => onChange(Number(event.target.value))} />
    <span className="compact-range-value"><PrecisionControl externalValue={externalValue} label={label} inputLabel={inputLabel} value={value} min={min} max={max}
      step={step} integer={integer} disabled={disabled} onChange={onChange} invalidMessage={invalidMessage} />{unit && <span aria-hidden="true">{unit}</span>}</span>
  </div>;
}
